import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearchZoomIn = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8334 10.375H7.66675C7.32508 10.375 7.04175 10.0917 7.04175 9.75C7.04175 9.40833 7.32508 9.125 7.66675 9.125H11.8334C12.1751 9.125 12.4584 9.40833 12.4584 9.75C12.4584 10.0917 12.1751 10.375 11.8334 10.375Z",
			fill: "#8E68F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.75 12.4587C9.40833 12.4587 9.125 12.1753 9.125 11.8337V7.66699C9.125 7.32533 9.40833 7.04199 9.75 7.04199C10.0917 7.04199 10.375 7.32533 10.375 7.66699V11.8337C10.375 12.1753 10.0917 12.4587 9.75 12.4587Z",
			fill: "#8E68F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.58342 18.1253C4.87508 18.1253 1.04175 14.292 1.04175 9.58366C1.04175 4.87533 4.87508 1.04199 9.58342 1.04199C14.2917 1.04199 18.1251 4.87533 18.1251 9.58366C18.1251 14.292 14.2917 18.1253 9.58342 18.1253ZM9.58342 2.29199C5.55841 2.29199 2.29175 5.56699 2.29175 9.58366C2.29175 13.6003 5.55841 16.8753 9.58342 16.8753C13.6084 16.8753 16.8751 13.6003 16.8751 9.58366C16.8751 5.56699 13.6084 2.29199 9.58342 2.29199Z",
			fill: "#8E68F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.3333 18.9585C18.175 18.9585 18.0166 18.9002 17.8916 18.7752L16.225 17.1085C15.9833 16.8669 15.9833 16.4669 16.225 16.2252C16.4666 15.9835 16.8666 15.9835 17.1083 16.2252L18.775 17.8919C19.0166 18.1335 19.0166 18.5335 18.775 18.7752C18.65 18.9002 18.4916 18.9585 18.3333 18.9585Z",
			fill: "#8E68F7"
		})
	]
});
export default SvgSearchZoomIn;
